import { AxiosError } from "axios";

/**
 * Narrows an unknown thrown value to an Error.
 * @param e The caught value
 * @returns The value itself when it is already an Error, otherwise an Error describing it
 */
export function toError(e: unknown): Error {
    if (e instanceof Error) return e;
    return new Error(typeof e === "string" ? e : JSON.stringify(e));
}

/**
 * Narrows an unknown thrown value to an Axios error. The installed axios has no static helper for this.
 * @param e The caught value
 * @returns Whether the value carries an Axios response
 */
export function isAxiosError(e: unknown): e is AxiosError {
    return e instanceof Error && "isAxiosError" in e && e.isAxiosError === true;
}
